import React from "react";
import useAuths from '../../../../hooks/UseAuths';

export const AdminPage = () => {
  const {logout,authState} = useAuths();
  console.log(authState,"AuthState ");
  return (
    <div>
      <h1>Admin Page - Protected</h1>
      <p>Only authenticated users can see this.</p>
      <button className='oktaLogin' onClick={()=>{logout()}}>LogOut</button>
    </div>
  );
};